import { __assign as i } from "./index60.mjs";
import { ErrorKind as l } from "./index55.mjs";
import { Parser as n } from "./index56.mjs";
import { isSelectElement as o, isPluralElement as m, isNumberElement as E, isNumberSkeleton as u, isDateElement as c, isTimeElement as f, isDateTimeSkeleton as p, isTagElement as T } from "./index57.mjs";
import { SKELETON_TYPE as N, TYPE as b, isArgumentElement as y, isLiteralElement as D, isPoundElement as _ } from "./index57.mjs";
function r(t) {
  t.forEach(function(e) {
    if (delete e.location, o(e) || m(e))
      for (var s in e.options)
        delete e.options[s].location, r(e.options[s].value);
    else E(e) && u(e.style) || (c(e) || f(e)) && p(e.style) ? delete e.style.location : T(e) && r(e.children);
  });
}
function P(t, e) {
  e === void 0 && (e = {}), e = i({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, e);
  var s = new n(t, e).parse();
  if (s.err) {
    var a = SyntaxError(l[s.err.kind]);
    throw a.location = s.err.location, a.originalMessage = s.err.message, a;
  }
  return e != null && e.captureLocation || r(s.val), s.val;
}
export {
  N as SKELETON_TYPE,
  b as TYPE,
  y as isArgumentElement,
  c as isDateElement,
  p as isDateTimeSkeleton,
  D as isLiteralElement,
  E as isNumberElement,
  u as isNumberSkeleton,
  m as isPluralElement,
  _ as isPoundElement,
  o as isSelectElement,
  T as isTagElement,
  f as isTimeElement,
  P as parse
};
